/** Tracks in-flight axios requests created via `redux/actions/api`. */

let pendingCount = 0;
const listeners = new Set();

const notify = () => {
  listeners.forEach((fn) => {
    try {
      fn(pendingCount);
    } catch {
      // ignore listener errors
    }
  });
};

export const getPendingApiCount = () => pendingCount;

export const incrementPendingApi = () => {
  pendingCount += 1;
  notify();
};

export const decrementPendingApi = () => {
  pendingCount = Math.max(0, pendingCount - 1);
  notify();
};

/**
 * Waits until screen APIs have started (or startTimeout) and then gone idle.
 * Call after data-sharing and after Router/screens are allowed to mount.
 *
 * @param {{ startTimeoutMs?: number, idleMs?: number, timeoutMs?: number }} [opts]
 */
export async function waitForScreenApisIdle({
  startTimeoutMs = 2500,
  idleMs = 400,
  timeoutMs = 45000,
} = {}) {
  const startedAt = Date.now();

  // Let React mount screens and schedule their useEffects
  await new Promise((r) => setTimeout(r, 50));

  // Wait until at least one request starts, or give up waiting to start
  while (
    getPendingApiCount() === 0 &&
    Date.now() - startedAt < startTimeoutMs
  ) {
    await new Promise((r) => setTimeout(r, 40));
  }

  // Wait until no pending requests for idleMs (all responses received)
  let idleSince = null;
  while (Date.now() - startedAt < timeoutMs) {
    if (getPendingApiCount() === 0) {
      if (idleSince == null) idleSince = Date.now();
      if (Date.now() - idleSince >= idleMs) return;
    } else {
      idleSince = null;
    }
    await new Promise((r) => setTimeout(r, 40));
  }
}
